import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postCall, deleteCall, getById, BASE_URL } from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
  data: [],
  cardDetail: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getCard = createAsyncThunk(
  "Card/get",
  async ({ payload, page = 1, per_page = 50 }) => {
    try {
      const response = await postCall(
        `/admin/v1/all_card?page=${page}&per_page=${per_page}`,
        payload,
        false
      );
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCardById = createAsyncThunk("Card/getById", async (id) => {
  try {
    const response = await getById("/admin/v1/show_card", id, false);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const addCard = createAsyncThunk("Card/add", async (name) => {
  try {
    const response = await postCall("/admin/v1/add_card", name);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateCard = createAsyncThunk(
  "card/updateCard",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_card/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "Card updated successfully!");
      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCardDisplay = createAsyncThunk(
  "card/updateCardDisplay",
  async ({ id, formData }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await axios.post(
        `${BASE_URL}/admin/v1/update_card/${id}/display`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message || "Card updated display successfully!");
      return response.data;
    } catch (error) {
      toast.error("Unable to update data. Please try again later.");
      return rejectWithValue(error.response.data);
    }
  }
);

export const multipleDeleteCard = createAsyncThunk("Card/delete", async (id) => {
  try {
    await deleteCall(`/admin/v1/delete_card?card_id=${id}`);
    return await id;
  } catch (error) {
    return Promise?.reject(error);
  }
});
const CardSlice = createSlice({
  name: "Card",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCard.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getCardById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCardById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.cardDetail = action.payload;
      })
      .addCase(getCardById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addCard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(addCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateCard.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateCard.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state?.data?.data?.findIndex(
          (card) => card.id === action.payload.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateCard.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
   
      .addCase(multipleDeleteCard.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

      .addCase(multipleDeleteCard.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (Card) => Card.id !== action.payload
        );
      })
      .addCase(multipleDeleteCard.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateCardDisplay.pending, (state) => {
        // state.status = "loading";
        state.error = null;
      })
      .addCase(updateCardDisplay.fulfilled, (state, action) => {
        // state.status = "succeeded";
        const index = state.data.data.findIndex(card => card.id === action.payload.data.id);
        if (index !== -1) {
          state.data.data[index].display = action.payload.data.display;
        }
      })
      .addCase(updateCardDisplay.rejected, (state, action) => {
        // state.status = "failed";
        state.error = action.payload?.message || "Failed to update card display";
      });
  },
});

export default CardSlice.reducer;
